<template>
    <div class="news">
        <b-container fluid class="h100">
            <b-row class="h100">
                <b-col cols="9">
                    <b-row class="px300">
                        <b-col cols="6" class="bgw">
                            <h3>
                                Have you noticed missing or incorrect data ?<br>
                                Do you have any suggestion on how to improve<br>
                                this platform ?
                                <button class="btn btn-info" @click="sendmailto()"><span>CONTACT US</span></button>
                                <img src="images/cell.png">
                            </h3>
                        </b-col>
                        <b-col cols="6" class="bgw">
                            <h3>
                                Do you have any doubt on My.Marsilli ?<br>
                                Have a look at our tutorial on how to make the most
                                of the full potentil of this platform!<br>
                                <button class="btn btn-info" @click="download()"><span>DOWNLOAD TUTORIAL</span></button>
                                <img src="images/info.png">
                            </h3>
                        </b-col>
                    </b-row>
                    <b-row class="h65">
                        <b-col class="bgw2">
                            <h1>Closing Days</h1>
                            <FullCalendar ref="fullCalendar" :options="calendarOptions">
                                <template #eventContent="arg">
                                    <div class="custom-event">
                                        <div :class="'event-title ' + arg.event.extendedProps.sede" :title="arg.event.title + ' (' + arg.event.extendedProps.sede + ')'">{{ arg.event.title }}</div>
                                    </div>
                                </template>
                            </FullCalendar>
                        </b-col>
                    </b-row>
                    <b-row class="h50" v-if="false">
                        <b-col cols="6" class="bgw">
                            <h3>
                                Do you have suggestions<br>
                                on how to improve this platform?<br>
                                <button class="btn btn-info" @click="sendmailto()"><span>CONTACT US</span></button>
                                <img src="images/lamp.png">
                            </h3>
                        </b-col>
                        <b-col cols="6" class="bgw">
                            <h3>
                                Do you have any doubt about this platform?<br>
                                Would you like to have a call<br>
                                with one of our experts?<br>
                                <button class="btn btn-info" @click="sendmailto()"><span>ASK FOR A MEETING</span></button>
                                <img src="images/question.png">
                            </h3>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="3" class="right">
                    <br>
                    <h3>CONTACTS</h3>
                    <img src="images/mail.png">
                    <br><br>
                    <a href="mailto:service@marsilli.it">service@marsilli.com</a>
                    <br><br>
                    <a href="mailto:spareparts@marsilli.it">spareparts@marsilli.com</a>
                    <br><br>
                    <a href="mailto:repairs@marsilli.it">repairs@marsilli.com</a>
                    <br>
                    <hr>
                    <img src="images/phone.png">
                    <br><br>
                    <h3>REMOTE ASSISTANCE<br>
                        AND ONSITE VISIT REQUESTS
                    </h3>
                    <br>
                    <a href="tel:+39 0374 355 434@marsilli.it">Europe: +39 0374 355 434</a>
                    <br><br>
                    <a href="tel:+1 410 654 2425@marsilli.it">USA and Mexico: +1 410 654 2425</a>
                    <br><br>
                    <a href="tel:+86 512 8080 2345@marsilli.it">China: +86 512 8080 2345</a>
                    <br><br>
                    <a href="tel:+91-80 4211 4632@marsilli.it">India: +91-80 4211 4632</a>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import 'vue-loading-overlay/dist/vue-loading.css';
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import multiMonthPlugin from '@fullcalendar/multimonth'
import { API } from "@/api.js";

export default {
    name: "Support",
    components: {
        FullCalendar // make the <FullCalendar> tag available
    },
    data() {
        return {
            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin, // needed for dateClick
                    multiMonthPlugin
                ],
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'multiMonthYear,dayGridMonth'
                },
                initialView: 'multiMonthYear',
                editable: false,
                selectable: false,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                eventsSet: this.handleEvents,
                firstDay: 1,
                /* you can update a remote database when these fire:
                eventAdd:
                eventChange:
                eventRemove:
                */
            },
            events: []
        };
    },
    computed: {
    },
    async mounted() {
        let date = await API.closingTime();
        this.events = date.map((d) => {
            return {
                id: d.id,
                title: d.title,
                start: d.data,
                sede: d.sede,
                allDay: !d.ora
            }
        });
        console.log("events", this.events)
        let calendarApi = this.$refs.fullCalendar.getApi()
        calendarApi.addEventSource(this.events)
        this.waiting = false;
    },
    methods: {
        sendmailto() {
            window.location = "mailto:helpdesk.service@marsilli.com"
        },
        download() {
            window.open("My.Marsilli.pdf")
        },
        handleWeekendsToggle() {
            this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
        },

        handleEvents(events) {
            this.currentEvents = events
        }

    },
};
</script>
<style></style>
<style scoped>
button.btn-info {
    position: absolute;
    /* right: 0px; */
    bottom: 40px;
    left: calc(50% - 75px);
    width: 150px;
}

div.bgw h3 {
    margin-top: 60px;
}

button.btn-info {
    margin-top: 20px;
    background-color: #9A240D;
    border-color: #9A240D;
}

div.right {
    background-color: #9A240D;
    height: 100%;
}

div.news {
    height: 87vh;
    padding: 10px;
    background-color: lightgray;
}

div.h100 {
    height: 100%;
}

div.h65 {
    height: 65%;
}

div.h50 {
    height: 50%;
}

div.px300 {
    height: 300px;
}

div.bgw {
    background-color: white;
    margin: 5px;
    box-sizing: border-box;
    max-width: calc(50% - 20px);
    width: calc(50% - 20px);
}

div.bgw2 {
    background-color: white;
    margin: 5px;
    box-sizing: border-box;
    max-width: calc(100% - 30px);
    width: calc(100% - 30px);
}

h3 img {
    width: 100px;
    position: absolute;
    right: 75px;
    bottom: 20px;
}

div.right {
    color: white;
    margin-top: 5px;
    margin-bottom: 5px;
}

div.right hr {
    background-color: white;
}

div.right a {
    color: white;
}
div.MEX {
    background-color: #9A240D;
}
div.HQ {
    background-color: darkgreen;
}
div.USA {
    background-color: darkblue;
}
div.deu {
    background-color: darkorange;
}
</style>
